import React from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { ConfigProvider as AntdConfigProvider } from "antd";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Provider } from "react-redux";
import store from "./store";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "antd/dist/antd.variable.min.css";
import "assets/styles/styles.scss";
import "index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));

const direction = "ltr";
const persistor = persistStore(store);

AntdConfigProvider.config({
  theme: {
    primaryColor: "#356AB3",
  },
});

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AntdConfigProvider direction={direction}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AntdConfigProvider>
    </PersistGate>
  </Provider>
);
